module.exports = __webpack_public_path__ + "static/img/TW.fb573f18.png";